import ClickAndCollectSearchMapView from './ClickAndCollectSearchMapView';

export default ClickAndCollectSearchMapView;
